export default __webpack_public_path__ + "ad8a55ab81f32fb705da9ba9228e480e.png";